import React from "react";
import PropTypes from "prop-types";

class Background extends React.Component {
  render() {
    let background = null;
    let src = null;
    let classNames = "";
    let color = null;

    if (this.props.layer.color && this.props.layer.has_color) {
      color = this.props.layer.color;
      if (color) {
        src = color.image;
        classNames =
          this.props.layer.height === 0 || this.props.layer.height === ""
            ? "stretched"
            : "";
      }
    }

    if (this.props.layer.use_layer_mask && this.props.layer.layer_mask) {
      // use masked background template. load image into that template
      let path = `layer-mask?color_id=${color.id}&design_id=${this.props.design.id}&layer_id=${this.props.layer.layer_id}`;
      classNames += " stretched";
      src = process.env.REACT_APP_TEXT_EFFECTS_URL + path;
    }

    const className =
      "background " + (this.props.layer.is_cutout ? " shadow" : "");

    if (src) {
      background = (
        <div className={className}>
          <img
            draggable="false"
            src={src}
            className={`background__product-image ${classNames}`}
            alt=""
          />
        </div>
      );
    }
    return background;
  }
}

Background.propTypes = {
  layer: PropTypes.object,
  design: PropTypes.object,
};

export default Background;
